import { UnidadeMedidaEnum } from "core/features/orcamento/typings";

export function getUnidadeMedida(
  status: UnidadeMedidaEnum,
) {
  switch (status) {
    case UnidadeMedidaEnum.Unidade:
      return  "unidade";
    case UnidadeMedidaEnum.Metro:
      return  "metro";
    case UnidadeMedidaEnum.MetroQuadrado:
      return  "metro quadrado";
    case UnidadeMedidaEnum.MetroCubico:
      return  "metro cubico";
    case UnidadeMedidaEnum.Quilo:
      return  "quilo";
    case UnidadeMedidaEnum.Grama:
      return  "grama";
      case UnidadeMedidaEnum.Litro:
      return "litro";
      case UnidadeMedidaEnum.Mililitro:
      return  "mililitro";
      case UnidadeMedidaEnum.Minuto:
      return  "minuto";
      case UnidadeMedidaEnum.Hora:
      return  "hora";
      case UnidadeMedidaEnum.Dia:
      return  "dia";
      case UnidadeMedidaEnum.Mes:
      return  "mês";
      case UnidadeMedidaEnum.Ano:
      return  "ano";
    default:
      return "gray";
  }
}
